import React from 'react';
import { Package, X } from 'lucide-react';

export function AdminModal({ title, children, onClose, wide = false }) {
  return (
    <div className="adminModalLayer" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={wide ? 'adminModal adminModal--wide' : 'adminModal'}>
        <div className="adminModalHead">
          <h3>{title}</h3>
          <button type="button" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="adminModalBody">{children}</div>
      </div>
    </div>
  );
}

export function AdminFilterBar({ children }) {
  return <div className="adminFilterBar">{children}</div>;
}

export function EmptyState({ title, body }) {
  return (
    <div className="emptyState">
      <Package size={32} />
      <strong>{title}</strong>
      <span>{body}</span>
    </div>
  );
}

export function Metric({ label, value, icon, tone = 'navy', help }) {
  return (
    <div className={`metric ${tone}`}>
      <div className="metric-icon">{icon}</div>
      <span className="metric-label">{label}</span>
      <strong className="metric-value">{value}</strong>
      {help && <small className="metric-help">{help}</small>}
    </div>
  );
}

export function usePagedRows(rows, defaultSize = 20) {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(defaultSize);
  React.useEffect(() => setPage(1), [rows.length, pageSize]);
  const totalPages = pageSize === 9999 ? 1 : Math.max(1, Math.ceil(rows.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const paged = pageSize === 9999 ? rows : rows.slice((safePage - 1) * pageSize, safePage * pageSize);
  return { page: safePage, pageSize, setPage, setPageSize, totalPages, paged };
}

export function Pager({ state, total }) {
  return (
    <div className="adminPager">
      <span>Showing {state.paged.length} of {total}</span>
      <label>
        Show
        <select value={state.pageSize} onChange={(e) => state.setPageSize(Number(e.target.value))}>
          {[10, 20, 50, 100].map((n) => <option value={n} key={n}>{n}</option>)}
          <option value={9999}>All</option>
        </select>
      </label>
      <button type="button" onClick={() => state.setPage(Math.max(1, state.page - 1))} disabled={state.page <= 1}>Prev</button>
      <strong>{state.page} / {state.totalPages}</strong>
      <button type="button" onClick={() => state.setPage(Math.min(state.totalPages, state.page + 1))} disabled={state.page >= state.totalPages}>Next</button>
    </div>
  );
}

export const STATUS_LABELS = {
  processing: 'Payment Received',
  paid: 'Payment Received',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled'
};
export const STATUS_OPTIONS = ['processing', 'shipped', 'delivered', 'cancelled'];

export function orderStatus(order) {
  return order.deliveryStatus || order.status || 'processing';
}
export function orderStudent(order) {
  return order.delivery?.name || order.studentName || 'Customer';
}
export function orderPhone(order) {
  const raw = order.delivery?.phone || order.studentPhone || order.phone || '';
  return String(raw || '').replace(/\D/g, '').slice(-10);
}
export function orderTotal(order) {
  return (order.items || []).reduce((s, i) => s + Number(i.price || 0) * Number(i.qty || 1), 0) || Number(order.total || 0);
}
export function totalUnits(order) {
  return (order.items || []).reduce((s, i) => s + Number(i.qty || 1), 0);
}

export function StatusBadge({ status }) {
  const classMap = { processing: 'b-proc', paid: 'b-proc', shipped: 'b-ship', delivered: 'b-dlvd', cancelled: 'b-canc' };
  return <span className={`badge ${classMap[status] || 'b-proc'}`}>{STATUS_LABELS[status] || status}</span>;
}
